var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrlOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.99219C7.22386 6.99219 7 7.21605 7 7.49219C7 7.4948 7.00002 7.4974 7.00006 7.5C7.00002 7.5026 7 7.5052 7 7.50781V16.4922V16.5078C7 16.784 7.22386 17.0078 7.5 17.0078C7.54299 17.0078 7.5847 17.0024 7.62451 16.9922L16.5 16.9922C16.7761 16.9922 17 16.7683 17 16.4922V13.4922C17 13.216 16.7761 12.9922 16.5 12.9922C16.2239 12.9922 16 13.216 16 13.4922V15.9922H8L8 7.99219H10.5C10.7761 7.99219 11 7.76833 11 7.49219C11 7.21605 10.7761 6.99219 10.5 6.99219H7.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.49219C13 7.21605 13.2239 6.99219 13.5 6.99219H16.5C16.7761 6.99219 17 7.21605 17 7.49219V10.4922C17 10.7683 16.7761 10.9922 16.5 10.9922C16.2239 10.9922 16 10.7683 16 10.4922L16 8.69933L12.8536 11.8458C12.6583 12.041 12.3417 12.041 12.1464 11.8458C11.9512 11.6505 11.9512 11.3339 12.1464 11.1387L15.2929 7.99219H13.5C13.2239 7.99219 13 7.76833 13 7.49219Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlOpen);
export default __webpack_public_path__ + "static/media/urlOpen.6596b9261d0afc9b2cca94103e97d8de.svg";
export { ForwardRef as ReactComponent };